import { reactive } from "vue";

export default function useValidations() {
  const errors = reactive({});

  /**
   * Validar campos individuales en el formulario
   * @param {Object} formData - Los datos del formulario
   * @returns {Boolean} - Indica si todos los campos son válidos
   */
  const validateFields = (formData) => {
    let isValid = true;

    if (!formData.dni) {
      errors.dni = "El DNI es obligatorio.";
      isValid = false;
    } else {
      errors.dni = null;
    }

    if (!formData.name || formData.name.trim() === "") {
      errors.name = "El nombre es obligatorio.";
      isValid = false;
    } else {
      errors.name = null;
    }

    if (!formData.lastname || formData.lastname.trim() === "") {
      errors.lastname = "El apellido es obligatorio.";
      isValid = false;
    } else {
      errors.lastname = null;
    }

    if (!formData.email || !isValidEmail(formData.email)) {
      errors.email = "Debe ingresar un correo electrónico válido.";
      isValid = false;
    } else {
      errors.email = null;
    }


    /*if (!formData.business_phone || !isValidPhone(formData.business_phone)) {
      errors.business_phone = "Debe ingresar un teléfono fijo válido.";
      isValid = false;
    } else {
      errors.business_phone = null;
    }*/



    if (formData.personal_phone && !isValidPhone(formData.personal_phone)) {
      errors.personal_phone = "Debe ingresar un celular válido.";
      isValid = false;
    } else if (formData.personal_phone.trim() === "") {
      errors.personal_phone = "El teléfono celular es obligatorio.";
      isValid = false;
    } else {
      errors.personal_phone = null;
    }



    if (formData.password) {
      const password = formData.password;
      const confirmPassword = formData.confirm_password;
      const dni = formData.dni ? String(formData.dni) : "";
      const email = formData.email || "";

      // Individual rules for real-time feedback
      const meetsLength = password.length >= 8;
      const meetsUppercase = /[A-Z]/.test(password);
      const meetsLowercase = /[a-z]/.test(password);
      const meetsNumber = /[0-9]/.test(password);
      const meetsSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(password);
      const meetsNoDni = dni ? !password.includes(dni) && password !== dni : true;
      const meetsNoEmail = password !== email;
      const meetsMatch = confirmPassword !== undefined ? password === confirmPassword : true;

      if (!meetsLength) {
        errors.password = "La contraseña debe tener al menos 8 caracteres.";
        isValid = false;
      } else if (!meetsUppercase) {
        errors.password = "Debe incluir al menos una mayúscula.";
        isValid = false;
      } else if (!meetsLowercase) {
        errors.password = "Debe incluir al menos una minúscula.";
        isValid = false;
      } else if (!meetsNumber) {
        errors.password = "Debe incluir al menos un número.";
        isValid = false;
      } else if (!meetsSpecial) {
        errors.password = "Debe incluir al menos un carácter especial.";
        isValid = false;
      } else if (!meetsNoDni) {
        errors.password = "La contraseña no puede contener el DNI.";
        isValid = false;
      } else if (!meetsNoEmail) {
        errors.password = "La contraseña no puede ser igual al email.";
        isValid = false;
      } else {
        errors.password = null;
      }

      if (confirmPassword !== undefined && !meetsMatch) {
        errors.confirm_password = "Las contraseñas no coinciden.";
        isValid = false;
      } else {
        errors.confirm_password = null;
      }
    } else {
      errors.password = null;
      errors.confirm_password = null;
    }
    console.log("errors", errors)
    return isValid;
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isValidPhone = (phone) => {
    const phoneRegex = /^[0-9]{8,15}$/;
    return phoneRegex.test(phone);
  };

  const clearError = (field) => {
    if (errors[field]) {
      errors[field] = null;
    }
  };

  return {
    errors,
    validateFields,
    clearError,
  };
}
